// extracted by mini-css-extract-plugin
module.exports = {"rowFlex":"eSOF+JBeSSyns8Cn7MeeQQ==","columnFlex":"_7iHAGMOn3gR78nCHuCt9PQ==","wrapper":"CsiYhMdjVXuJOVd2WhTsdA==","alignText":"_8hcfpmbbNhqje+prr2pnaA=="};